var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',{directives:[{name:"rw",rawName:"v-rw"}],staticStyle:{"width":"60px"},attrs:{"type":"error","custom-icon":_vm.value ? 'fa fa-lock-open' : 'fas fa-lock',"text":"sort","ghost":""},on:{"on-click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }